var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckBlueOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6970_8663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50011 13.4751L4.60845 10.5834C4.28345 10.2584 3.75845 10.2584 3.43345 10.5834C3.10845 10.9084 3.10845 11.4334 3.43345 11.7584L6.91678 15.2418C7.24178 15.5668 7.76678 15.5668 8.09178 15.2418L16.9084 6.4251C17.2334 6.1001 17.2334 5.5751 16.9084 5.2501C16.5834 4.9251 16.0584 4.9251 15.7334 5.2501L7.50011 13.4751Z",
    fill: "#00A0F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6970_8663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBlueOutlined);
export default __webpack_public_path__ + "static/media/CheckBlueOutlined.691f1aece5b2f7677c2ed3de34167909.svg";
export { ForwardRef as ReactComponent };